const UPPERCASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const LOWERCASE = "abcdefghijklmnopqrstuvwxyz";
const NUMBERS = "0123456789";
const SYMBOLS = "!@#$%^&*()-_=+[]{}<>?";

const getRandomInt = (max) => {
  if (max <= 0) return 0;
  if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) {
    const randomValues = new Uint32Array(1);
    window.crypto.getRandomValues(randomValues);
    return randomValues[0] % max;
  }
  return Math.floor(Math.random() * max);
};

const pick = (charset) => charset[getRandomInt(charset.length)];

const shuffle = (arr) => {
  const next = [...arr];
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = getRandomInt(i + 1);
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
};

export const generateStrongPassword = (length = 16) => {
  const safeLength = Math.max(12, Number(length) || 16);
  const all = `${UPPERCASE}${LOWERCASE}${NUMBERS}${SYMBOLS}`;

  const chars = [pick(UPPERCASE), pick(LOWERCASE), pick(NUMBERS), pick(SYMBOLS)];
  for (let i = chars.length; i < safeLength; i += 1) {
    chars.push(pick(all));
  }

  return shuffle(chars).join("");
};

